<div class="panel panel-info">
    @if (patient) {
        <div class="panel-heading pt-1"></div>
        <div class="panel-body pb-3 px-3">
            <div class="container-flex">
                <div class="row mx-0 mb-2">
                    <app-patient-address class="col-8" [patient]="patient"></app-patient-address>
                    <app-patient-main-responsibles
                        class="container-flex col-4"
                        [patientId]="patient.patientId"
                    ></app-patient-main-responsibles>
                </div>
                <div class="container-flex">
                    <app-patient-tasks [patient]="patient"></app-patient-tasks>
                </div>
            </div>
        </div>
    }
    @if (patient === undefined) {
        <span class="spinner spinner-lg absolute-centering"></span>
    }
    @if (patient === null) {
        <span class="centering-flex">{{ 'NO_PATIENTS' | translate }}</span>
    }
</div>
